import React, { useEffect, useState } from 'react'
import client from '../../client/Client'
import { useParams } from 'react-router-dom'
import './HeaderBanner.css'

const HeaderBanner = (props: { title: string }) => {
  const pageVersion = useParams()
  const [version, setVersion] = useState<{ YearVersion: string }>({ YearVersion: "" })

  useEffect(() => {
    if (props.title !== 'Previous version' && props.title !== 'Technical program') {
      client.fetch('*[_type == "YearVersion"]').then((result) => {
        if (result.length > 0) setVersion(result[0])
      }).catch((error) => console.error('Error fetching data:', error))
    }
  }, [props.title])

  return (
    <div className="relative flex items-center my-6">
      {/* Title */}
      <div
        className={`
          absolute 
          grid justify-items-center 
          top-20 
          left-10 sm:left-28   /* mobile → desktop */
          w-full z-10
        `}
      >
        {props.title === 'Technical Program' ? (
          <h1 className="text-xl sm:text-3xl title text-red-600 font-bold mb-6">
            Technical Program-SSD{pageVersion?.version}
          </h1>
        ) : props.title === 'Previous version' ? (
          <h1 className="text-xl sm:text-3xl title text-red-600 font-bold mb-6">
            {props.title}-{pageVersion.version}
          </h1>
        ) : (
          <h1 className="text-xl sm:text-3xl title text-red-600 font-bold mb-6">
            {props.title}-SSD{version.YearVersion}
          </h1>
        )}
      </div>

      {/* Banner background */}
      <section
        className="
          relative w-full h-64 bg-cover bg-center py-24
          bg-no-repeat
          bg-[length:80%] sm:bg-[length:60%]   /* mobile → desktop */
        "
        style={{
          backgroundImage: "url('/images/pulse1.png')"
        }}
      >
        <div className="container mx-auto text-center text-white"></div>
      </section>
    </div>
  )
}

export default HeaderBanner
